module.exports = "var PersonalizationConstants = {\n    localStorageName : 'UserPersonalization.DMP',\n    localStorageNameToUpdate : 'UserPersonalization.Update',\n    cookieCustomerLVP: 'CUSTOMER_LVP',\n\n    actors : {\n        SEND_USER_PERSONALIZATION:'/rest/model/atg/userprofiling/ProfileActor/setUserPersonalization'\n    }\n};\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./src/analytics/legacy/personalization/framework/PersonalizationConstants.legacy.js
// module id = 814
// module chunks = 31